import { atlassianStore as store } from 'src/utils/store';

const MAX_RECENTS = 5;

type User = {
  uuid: string;
};

export type RecentWorkspace = {
  uuid: string;
  slug: string;
};

const oldStorageName = (user: User) =>
  `recently-viewed-workspace-uuids:${user.uuid}`;
const storageName = (user: User) => `recently-viewed-workspaces:${user.uuid}`;

function addWorkspaceToRecents(
  recentWorkspaces: RecentWorkspace[],
  workspace: RecentWorkspace
): RecentWorkspace[] {
  const idx = recentWorkspaces.findIndex(ws => ws.uuid === workspace.uuid);
  if (idx === 0) {
    return recentWorkspaces;
  } else if (idx > 0) {
    recentWorkspaces.splice(idx, 1);
  }
  return [workspace, ...recentWorkspaces];
}

function add(user: User, workspace: RecentWorkspace): void {
  if (store.enabled) {
    const key = storageName(user);
    const currentWorkspaces = store.get(key) || [];

    const workspaces = addWorkspaceToRecents(currentWorkspaces, workspace);
    store.setStrictlyNecessaryItem(key, workspaces.slice(0, MAX_RECENTS));
  }
}

function set(user: User, workspaces: RecentWorkspace[]): void {
  if (store.enabled) {
    store.setStrictlyNecessaryItem(storageName(user), workspaces);
  }
}

function get(user: User): RecentWorkspace[] {
  if (!store.enabled) {
    return [];
  }

  // remove the old storage key
  store.remove(oldStorageName(user));

  return store.get(storageName(user)) || [];
}

export const recentlyViewedWorkspacesStore = {
  get,
  set,
  add,
};
